import { SelectionState } from "@alfresco/adf-extensions";
import { MinimalNodeEntity } from "@alfresco/js-api";
import { Action } from "@ngrx/store";

export enum RecordActionTypes {
    CreateRecord = 'CREATE_RECORD',
    ViewRecord = 'VIEW_RECORD',
    EditRecord = 'EDIT_RECORD',
    DuplicateRecord = 'DUPLICATE_RECORD',
    DeleteRecord = 'DELETE_RECORD',
    OrganizeRecord = 'ORGANIZE_RECORD',
    EditMassiveRecord = 'EDIT_MASSIVE_RECORD',
    AssignLoanRecord = 'ASSIGN_LOAN',
}

export class CreateRecordAction implements Action {
  readonly type = RecordActionTypes.CreateRecord;

  constructor(public payload?: SelectionState) {}
}

export class ViewRecordAction implements Action {
  readonly type = RecordActionTypes.ViewRecord;

  constructor(public payload: MinimalNodeEntity[] = []) {}
}

export class EditRecordAction implements Action {
  readonly type = RecordActionTypes.EditRecord;

  constructor(public payload: MinimalNodeEntity[] = []) {}
}

export class DuplicateRecordAction implements Action {
  readonly type = RecordActionTypes.DuplicateRecord;

  constructor(public payload: MinimalNodeEntity[] = []) {}
}

export class DeleteRecordAction implements Action {
  readonly type = RecordActionTypes.DeleteRecord;

  constructor(public payload: MinimalNodeEntity[] = []) {}
}

export class OrganizeRecordAction implements Action {
  readonly type = RecordActionTypes.OrganizeRecord;

  constructor(public payload?: SelectionState) {}
}

export class EditMassiveRecordAction implements Action {
  readonly type = RecordActionTypes.EditMassiveRecord;

  constructor(public payload?: SelectionState) {}
}

export class AssignLoanRecordAction implements Action {
  readonly type = RecordActionTypes.AssignLoanRecord;

  constructor(public payload?: SelectionState) {}
}